var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';
var buildStyle = function (_a, _b) {
    var backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, font = _a.font;
    var readingDirection = _b.readingDirection;
    return {
        statusWrapper: __assign({ display: 'flex', backgroundColor: backgroundColor.base, justifyContent: 'space-between', fontFamily: font.base.family, fontSize: font.base.size.s, color: font.color.soft, borderTop: "2px solid " + borderColor.soft, padding: '6px 0' }, readingDirection),
        progressBarLabel: __assign({ textAlign: 'left' }, readingDirection),
        progressBarPercentage: __assign({ textAlign: 'right' }, readingDirection),
        wrapper: __assign({ position: 'relative', top: -24 }, readingDirection)
    };
};
var useStyle = function (isRtl) {
    var builtStyle = useBuildStyleWithTheme(buildStyle, { isRtl: isRtl });
    if (!builtStyle) {
        return {
            statusWrapper: {},
            progressBarLabel: {},
            progressBarPercentage: {},
            wrapper: {}
        };
    }
    var statusWrapper = builtStyle.statusWrapper, progressBarLabel = builtStyle.progressBarLabel, progressBarPercentage = builtStyle.progressBarPercentage, wrapper = builtStyle.wrapper;
    return {
        statusWrapper: statusWrapper,
        progressBarLabel: progressBarLabel,
        progressBarPercentage: progressBarPercentage,
        wrapper: wrapper
    };
};
export default useStyle;
